import React from "react";
import styled from "styled-components";
import { createThemedComponent } from "@vitalsource/vstui/themes";
import QuestionMarkAndMenu from "./question-mark-and-menu";
import { shouldShowReadOffline } from "../../../utils/read-offline";
import { Translation, t } from "../../../core/translate";
import { Button } from "@vitalsource/vstui";
import MediaQueryOverride from "../../../components/mediaquery/media-query-override";
import { jsQueries } from "../../../components/mediaquery/breakpoints";
import CheggFooterRight from "./chegg-footer-right";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 50%;
`;

const VerticalBar = styled.span.attrs({
  "aria-hidden": "true"
})``;

const FootButton = styled(
  createThemedComponent(Button, { Button_paddingHorizontal_large: "15px" })
)``;

const Right = ({ chegg, redeem, showRedeem, theme }) => {
  if (chegg) {
    return <CheggFooterRight />;
  }
  return (
    <Wrapper>
      {shouldShowReadOffline() && [
        <MediaQueryOverride
          query={jsQueries.medium}
          size="medium"
          key="download-app-button"
        >
          <FootButton
            label={t("footer.download-our-app")}
            colorBehindButton={theme.vstui.color.white}
            naked
            color="white"
            tooltipPlacement="top"
            onClick={Fraction.Helpers.downloadApp}
            size="large"
            role="link"
          >
            <Translation id="footer.download-our-app" />
          </FootButton>
        </MediaQueryOverride>,
        <VerticalBar key="vert-bar">|</VerticalBar>
      ]}
      {showRedeem && (
        <MediaQueryOverride query={jsQueries.medium} size={"medium"}>
          <FootButton
            label={t("redeem.redeem-codes")}
            colorBehindButton={theme.vstui.color.white}
            naked
            color="white"
            onClick={redeem}
            tooltipPlacement="top"
            size="large"
          >
            <Translation id="redeem.redeem-codes" />
          </FootButton>
        </MediaQueryOverride>
      )}
      <QuestionMarkAndMenu />
    </Wrapper>
  );
};

export default Right;
